import * as THREE from "three";
import Experience from "../Experience.js";
import gsap from 'gsap'

const points = [
  {
    position: new THREE.Vector3(1.3, 2.0, -0.5),
    element: document.querySelector(".point-0"),
    moveTo: new THREE.Vector3(0, 2, -5),
  },
  {
    position: new THREE.Vector3(2.2, 1, 0.0),
    element: document.querySelector(".point-1"),
    moveTo: new THREE.Vector3(4.05, 1.0, -1),
  },
  {
    position: new THREE.Vector3(0, -4.6, 0.0),
    element: document.querySelector(".point-2"),
    moveTo: new THREE.Vector3(-0.5, -6.6, -0.5),
  },
  {
    position: new THREE.Vector3(1.2, 2.3, 0.5),
    element: document.querySelector(".point-3"),
    moveTo: new THREE.Vector3(1.6, 4.8, 2.2),
  },
];

export default class CalloutPoints {
  constructor() {
    this.experience = new Experience();
    this.resources = this.experience.resources;
    this.debug = this.experience.debug;
    this.scene = this.experience.scene;
    this.world = this.experience.world;
    this.time = this.experience.time;
    this.camera = this.experience.camera;
    this.sizes = this.experience.sizes;
    this.index = 0;
    this.setPoints();

    // window.addEventListener("wheel", (event) => {
    //   if (event.deltaY < 0) {
    //     this.index--;
    //     if (this.index < 0) this.index = 0;
    //   } else if (event.deltaY > 0) {
    //     this.index++;
    //     if (this.index > 50) this.index = 50;
    //   }

    //   points[0].element.classList.remove("hotspot__selected");
    //   points[1].element.classList.remove("hotspot__selected");
    //   points[2].element.classList.remove("hotspot__selected");
    //   points[3].element.classList.remove("hotspot__selected");
    //   if (this.index > 0 && this.index <= 6) {
    //     points[1].element.classList.toggle("hotspot__selected");
    //   } else if (this.index > 6 && this.index <= 16) {
    //     points[0].element.classList.toggle("hotspot__selected");
    //   } else if (this.index > 16 && this.index <= 40) {
    //     points[3].element.classList.toggle("hotspot__selected");
    //   } else if (this.index > 40 && this.index <= 50) {
    //     points[2].element.classList.toggle("hotspot__selected");
    //   }
     
    // });
  }

  setPoints() {
    this.raycaster = new THREE.Raycaster();

    // for (const point of points) {
      // point.element.addEventListener("click", (event) => {
      //   // Handle class "hotspot selected" to show details
      //   const clickedHotspot = event.target.parentElement;
      //   points.forEach((p) => {
      //     if (p.element === clickedHotspot) {
      //       p.element.classList.toggle("hotspot__selected");
      //     } else {
      //       p.element.classList.remove("hotspot__selected");
      //     }
      //   });

      //   // Animate camera position to point's moveTo.
        
      //   gsap.to(this.camera.modes.debug.instance.position, {
      //     x: point.moveTo.x,
      //     y: point.moveTo.y,
      //     z: point.moveTo.z,
      //     duration: 2,
      //     delay: 0,
      //     //ease: 'power3.inOut'
      //     ease: "elastic.out(2, 1)",
      //   });

      // });
    // }
  }

  update() {
    // Go through each point
    for (const point of points) {
      // Get 2D screen position
      const screenPosition = point.position.clone();
      screenPosition.project(this.camera.instance);

      // Set the raycaster
      this.raycaster.setFromCamera(screenPosition, this.camera.instance);
      const intersects = this.raycaster.intersectObjects(this.scene.children, true);

      // No intersect found
      if (intersects.length === 0) {
        // Show
        point.element.classList.add("visible");
      }

      // Intersect found
      else {
        // Get the distance of the intersection and the distance of the point
        const intersectionDistance = intersects[0].distance;
        const pointDistance = point.position.distanceTo(this.camera.instance.position);

        // Intersection is close than the point
        if (intersectionDistance < pointDistance) {
          // Hide
          point.element.classList.remove("visible");
        }
        // Intersection is further than the point
        else {
          // Show
          point.element.classList.add("visible");
        }
      }

      const translateX = screenPosition.x * this.sizes.width * 0.5;
      const translateY = -screenPosition.y * this.sizes.height * 0.5;
      point.element.style.transform = `translateX(${translateX}px) translateY(${translateY}px)`;
    }
  }
}
